import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { TrustBar } from '../components/TrustBar';
import { Marquee } from '../components/Marquee';
import { AboutSection } from '../components/AboutSection';
import { ServicesGrid } from '../components/ServicesGrid';
import { RoadsideSection } from '../components/RoadsideSection';
import { BeforeAfterSection } from '../components/BeforeAfterSection';
import { WhyChoose } from '../components/WhyChoose';
import { VehicleTypes } from '../components/VehicleTypes';
import { GallerySection } from '../components/GallerySection';
import { HowItWorks } from '../components/HowItWorks';
import { CtaBanner } from '../components/CtaBanner';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';

export default function HomePage() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <Marquee />
        <AboutSection />
       <ServicesGrid />
<BeforeAfterSection />
<RoadsideSection />
        <WhyChoose />
        <VehicleTypes />
        <GallerySection />
        <HowItWorks />
        <CtaBanner />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
